var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTask = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 489.6 489.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.65 52.2h-96.6V18c0-9.9-8.1-18-18-18h-150.4c-9.9 0-18 8.1-18 18v94.7c0 9.9 8.1 18 18 18h111.2c9.9 0 18-8.1 18-18s-8.1-18-18-18h-93.2V36h114.5v34.2c0 9.9 8.1 18 18 18h96.6v365.4H72.95V88.2h27.5c9.9 0 18-8.1 18-18s-8.1-18-18-18h-45.5c-9.9 0-18 8.1-18 18v401.4c0 9.9 8.1 18 18 18h379.7c9.9 0 18-8.1 18-18V70.2c0-9.9-8.1-18-18-18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M327.75 217c-7-7.1-18.4-7.1-25.5-.1l-83.9 83.2-30.7-30.9c-7-7.1-18.4-7.1-25.5-.1-7.1 7-7.1 18.4-.1 25.5l43.4 43.7c3.5 3.5 8.1 5.3 12.8 5.3 4.6 0 9.2-1.7 12.7-5.2l96.7-95.9c7.1-7 7.1-18.4.1-25.5z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTask, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/task.2cf001d1.svg";
export { ForwardRef as ReactComponent };